import theme from 'config/theme';

export default {
  checkboxField: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    alignItems: 'center',

    width: '100%',
    div: {
      width: '20px',
    },
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingY: '8px',
  },
  section: {
    padding: '8px',
    fontWeight: '700',
    backgroundColor: theme.palette.lightGray.main,
    marginBottom: '16px',
  },
  defaultField: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    '& > :first-child': {
      width: '50%',
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    '& > :last-child': {
      width: '50%',
    },
    label: {
      fontSize: '0.875rem',
    },
  },
  modalFooter: {
    width: '100%',
  },
  modalFooterIconButton: {
    marginRight: 'auto',
  },
};
